import { useState } from "react";
import { updatePricing } from "../../services/access.service";
import "../../styles/studio/pricingSection.css";

const CURRENCIES = ["USD", "EUR", "GBP", "INR"];

const PricingSection = ({ contentType, contentId, pricing, setPricing }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPricing((p) => ({ ...p, [name]: name === "price" ? Number(value) : value }));
    setSuccess(false);
    setError("");
  };

  const handleSave = async () => {
    setError(""); setSuccess(false);
    setLoading(true);
    try {
      await updatePricing(contentType, contentId, pricing);
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Failed to update pricing");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pricing-section">
      <h3 className="pricing-title">Pricing</h3>

      <div className="pricing-hint">
        {pricing.accessType === "private" && "Only you can view this content."}
        {pricing.accessType === "free" && "Anyone can view this content for free."}
        {pricing.accessType === "paid" && "Viewers need to purchase access."}
      </div>

      <div className="pricing-row">
        <div className="pricing-field">
          <label>Access</label>
          <select name="accessType" value={pricing.accessType} onChange={handleChange}>
            <option value="free">Free — anyone can view</option>
            <option value="private">Private — only you</option>
            <option value="paid">Paid — requires purchase</option>
          </select>
        </div>

        {pricing.accessType === "paid" && (
          <>
            <div className="pricing-field">
              <label>Price</label>
              <input
                type="number"
                name="price"
                min="0"
                step="0.01"
                value={pricing.price}
                onChange={handleChange}
              />
            </div>

            <div className="pricing-field">
              <label>Currency</label>
              <select name="currency" value={pricing.currency} onChange={handleChange}>
                {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div className="pricing-field">
              <label>Model</label>
              <select name="pricingModel" value={pricing.pricingModel} onChange={handleChange}>
                <option value="lifetime">Lifetime</option>
                <option value="subscription">Subscription</option>
              </select>
            </div>
          </>
        )}
      </div>

      {error && <p className="pricing-error">{error}</p>}
      {success && <p className="pricing-success">Pricing updated.</p>}

      <button className="pricing-save-btn" onClick={handleSave} disabled={loading}>
        {loading ? "Saving..." : "Save Pricing"}
      </button>
    </div>
  );
};

export default PricingSection;
